import React, { useState, useEffect } from 'react';

interface CounterProps {
  updatedAt: string;
}

const Counter: React.FC<CounterProps> = ({ updatedAt }) => {
  const [elapsedTime, setElapsedTime] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    const updateCounter = () => {
      const updatedAtDate = new Date(updatedAt);
      const now = new Date();
      const diff = now.getTime() - updatedAtDate.getTime(); // Convert to milliseconds

      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      setElapsedTime({ hours, minutes, seconds });
    };

    // Update the counter every second
    const intervalId = setInterval(updateCounter, 1000);

    // Cleanup interval on component unmount
    return () => clearInterval(intervalId);
  }, [updatedAt]);

  return (
    <>
      {elapsedTime.hours}h {elapsedTime.minutes}m {elapsedTime.seconds}s
    </>
  );
};

export default Counter;
